export default __webpack_public_path__ + "static/media/micronesia.152ee054.PNG";